import type {
  CreateDeliveryNotePdfExportMutationOptions,
  CreateDeliveryNotePdfExportPayload,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { createDeliveryNotePdfExport } from './createDeliveryNotePdfExport';

/**
 * Starts a delivery note PDF export. The job runs in the background; poll it
 * with `useQueryExportResult`.
 *
 * @param options - Additional mutation options.
 * @returns The export creation mutation.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/create_delivery_note_pdf_export_delivery_note_pdf_exports_post
 */
export const useMutationCreateDeliveryNotePdfExport = (
  options?: CreateDeliveryNotePdfExportMutationOptions,
) =>
  useMutation({
    ...options,
    mutationFn: async (payload: CreateDeliveryNotePdfExportPayload) =>
      createDeliveryNotePdfExport(payload),
  });
